import { UserAgentApplication } from 'msal';

export const LOGIN_SCOPES = ['openid', 'profile', 'user.read'];
const API_SCOPES = [
  'api://0c105e1c-8239-4e16-ab80-36168578b667/access_user_data',
];

export const aquireToken = () => {
  var userRequest = {
    scopes: API_SCOPES,
  };

  try {
    return msalApp.acquireTokenSilent(userRequest);
  } catch (error) {
    console.log('Error = ', error);
  }
};

export const msalApp = new UserAgentApplication({
  auth: {
    clientId: '9c0b13da-162f-486c-9d20-f8fff18d37dd',
    authority:
      'https://login.microsoftonline.com/95fec11e-0d2e-4a09-9adb-b0350750c752', //process.env.REACT_APP_AUTHORITY,
    validateAuthority: false,
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
});
